import { createContext } from "react";

interface SelectedChat {
	id?: string | number;
	date: string;
	deleted: boolean;
	messages: Array<object>;
	title: string;
	type: number;
	userId: string;
}

interface MyContextType {
	sessionId?: string;
	setSessionId?: React.Dispatch<React.SetStateAction<string>>;
	requireType?: string;
	setRequireType?: React.Dispatch<React.SetStateAction<string>>;
	selectedChat?: SelectedChat;
	setSelectedChat: React.Dispatch<React.SetStateAction<SelectedChat>>;
	conversationId: number;
	setConversationId: React.Dispatch<React.SetStateAction<number>>;
	isInputValue: boolean;
	setIsInputValue: React.Dispatch<React.SetStateAction<boolean>>;
	isLoad: boolean;
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>;
	recordList: any;
	setRecordList: React.Dispatch<React.SetStateAction<any>>;
	file: any;
	setFile: React.Dispatch<React.SetStateAction<any>>;
	fileUrl: any;
	setFileUrl: React.Dispatch<React.SetStateAction<any>>;
	hideSide: boolean;
	setHideSide: React.Dispatch<React.SetStateAction<boolean>>;
	seleConversation: any;
	deleItem: any;
	message: any;
	sendMessage: any;
	streamMessages: any;
	save: any;
	addSession: any;
	handleChange: any;
	messageId: any;
	setMessageId: any;
	current: any;
	setCurrent: any;
	needFresh: boolean;
	setNeedFresh: any;
	chatListData: any;
	setChatListData: any;
	getConversationList: any;
	listen: any;
	setListen: any;
	setSave: any;
	isLoading: any;
}

const MyContext = createContext<MyContextType | undefined>(undefined);

export default MyContext;
